import React, { useContext } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { useParams } from 'react-router-dom'
import { selectCrossClientResultExecutionLoading, selectCrossClientResultsExecution } from '../../../store/crossClient/crossClientResults'
import { CrossClientResultsInitialization } from './CrossClientResultsInitialization'
import { CrossClientResultsPoller } from './CrossClientResultsPoller'
import { CrossClientQueryPhase, CrossClientQueryPhases } from '../../../models/CrossClient'
import { Button } from '../../../components/Button/Button'
import { CrossClientTable } from '../Table/CrossClientTable'
import { useExportCrossClientResults } from './hooks'
import { CrossClientSidebar } from './Sidebar/CrossClientSidebar'
import { CrossClientMatchFilter } from './Filter/CrossClientMatchFilter'
import { CrossClientNameFilter } from './Filter/CrossClientNameFilter'
import { createPortal } from 'react-dom'
import { CrossClientHeader } from './Header/CrossClientHeader'
import { HeaderContext } from '../../LayoutWithLeftSidebar/HeaderContext'
import './CrossClientResults.scss'

export const CrossClientResults = () => {
  const { executionId } = useParams()

  if (!executionId) {
    return <div>No query provided</div>
  }

  return (
    <>
      <CrossClientResultsInitialization executionId={executionId} />
      <CrossClientResultsPoller executionId={executionId} />
      <CrossClientResultsBody executionId={executionId} />
    </>
  )
}

interface CrossClientResultsBodyProps {
  executionId: string
}

const EVALUATION_PHASES: CrossClientQueryPhase[] = [
  CrossClientQueryPhases.READY,
  CrossClientQueryPhases.PROCESSING,
  CrossClientQueryPhases.COMPLETED,
  CrossClientQueryPhases.ERRORED,
]

const CrossClientResultsBody: React.FC<CrossClientResultsBodyProps> = () => {
  const { portalRef } = useContext(HeaderContext)

  const execution = useAppSelector(selectCrossClientResultsExecution)
  const executionLoading = useAppSelector(selectCrossClientResultExecutionLoading)

  const { disabled: exportDisabled, exportCSV } = useExportCrossClientResults()

  if (executionLoading) {
    return <div className='skeleton pt-2 zocks-border-1.0' style={{ width: '100%', height: '60px' }} />
  }

  if (!execution) {
    return <div>Query not found</div>
  }

  if (!EVALUATION_PHASES.includes(execution.phase)) {
    return <div>Query is not in evaluation phase</div>
  }

  return (
    <div className='truly-full-size-content d-flex cross-client-results-container'>
      {portalRef && portalRef.current ? createPortal(<CrossClientHeader />, portalRef.current) : null}
      <div className='d-flex flex-column cross-client-results-left zocks-p-2.0 gap-4'>
        <div className='d-flex align-items-center justify-content-between gap-3'>
          <h4>{execution.userQuestion}</h4>
          <Button variant='primary' className='button-medium' onClick={exportCSV} disabled={exportDisabled}>
            <i className='bi bi-download' />
            Export
          </Button>
        </div>
        <div className='d-flex align-items-center justify-content-between'>
          <CrossClientMatchFilter />
          <CrossClientNameFilter />
        </div>
        <CrossClientTable />
      </div>
      <div className='cross-client-results-right'>
        <CrossClientSidebar />
      </div>
    </div>
  )
}
